import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { useAddAlert } from '@Modules/hubs/atoms'
import CopyLink from './CopyLink'
import media from '@Styles/media'
import { HubText } from 'src/common/rtl/HubWidgets'

type UserPVFieldProps = {
  fieldName: string
  fieldValue: string
}

const UserPVField: React.FC<UserPVFieldProps> = (props: UserPVFieldProps) => {
  const { fieldName, fieldValue } = props
  const intl = useIntl()
  const addAlert = useAddAlert()

  const handleCopy = () => {
    addAlert({
      message: `${fieldName} copied!`,
      type: 'SUCCESS',
    })
  }

  return (
    <>
      <UserPVFieldWrapper>
        <ProfileVariable>
          <ProfileText>{`${fieldName}:`}</ProfileText>&nbsp;<ProfileText>{fieldValue}</ProfileText>
        </ProfileVariable>
        <CopyWrapper onClick={handleCopy}>
          <CopyLink valueToCopy={fieldValue} includeTooltip={false} intl={intl} />
        </CopyWrapper>
      </UserPVFieldWrapper>
    </>
  )
}

const CopyWrapper = styled.div`
  position: relative;
  margin-left: 6px;
  opacity: 0;
  transition: opacity 150ms ease;
  cursor: pointer;

  :hover {
    opacity: 1;
  }

  ${media.smallerThanLargeScreen`
    opacity: 1;
  `};
`

const ProfileVariable = styled.div`
  display: flex;
`

const ProfileText = styled(HubText)`
  width: auto;
  height: fit-content;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover ~ ${CopyWrapper} {
    opacity: 1;
  }
`

const UserPVFieldWrapper = styled.div`
  display: flex;
  width: auto;
  padding-top: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.5;
  color: #666666;

  ${media.smallScreen`
    font-size: 10px;
  `};
`

export default UserPVField
